import React, { useState } from "react";
import T from "prop-types";
import {
  HEIGHT,
  LENGTH,
  NET_HEIGHT,
  NET_LENGTH,
  NET_WEIGHT,
  NET_WEIGHT_OZ,
  NET_WEIGHT_UNIT,
  NET_WIDTH,
  POUNDS,
  WIDTH
} from "MODULES/parts/constants";
import { NoteTooltip as IconTooltip } from "../../../shared/components/NoteTooltip";
import { partDimsCMText, partDimsText } from "../Search/Dimensions";
import {
  calculateNetValue,
  conversionUnitAbbrev
} from "../../../../lib/formatters/weight";

const hasValues = (part, values) =>
  values.every(f => ![undefined, null, ""].includes(part[f]));

export function NetWeightAndDimsPopUp({ part }) {
  const hasNetDimsAndWeight = hasValues(part, [
    NET_LENGTH,
    NET_WIDTH,
    NET_HEIGHT,
    NET_WEIGHT
  ]);

  const [copying, setCopying] = useState(false);

  if (!hasNetDimsAndWeight) {
    return null;
  }

  const translatedPart = {
    [LENGTH]: part[NET_LENGTH],
    [WIDTH]: part[NET_WIDTH],
    [HEIGHT]: part[NET_HEIGHT]
  };

  const dimsText = hasValues(part, [NET_LENGTH, NET_WIDTH, NET_HEIGHT])
    ? `Net Dm: ${partDimsText({ part: translatedPart })} | ${partDimsCMText({
        part: translatedPart
      })}`
    : "";

  const oz =
    part[NET_WEIGHT_UNIT] === POUNDS ? ` ${part.net_weight_oz} oz` : "";

  const weightText = hasValues(part, [NET_WEIGHT_UNIT, NET_WEIGHT])
    ? `Net Wt: ${part[NET_WEIGHT]} ${part[
        NET_WEIGHT_UNIT
      ]}${oz} | ${calculateNetValue(
        part[NET_WEIGHT_UNIT],
        part[NET_WEIGHT],
        part[NET_WEIGHT_OZ]
      )} ${conversionUnitAbbrev(part[NET_WEIGHT_UNIT])}`
    : "";

  const note = `${dimsText}\n${weightText}`;

  /* eslint-disable no-unused-expressions */
  const copy = () => {
    navigator.clipboard &&
      navigator.clipboard.writeText(note).then(() => {
        setCopying(true);
        setTimeout(() => {
          setCopying(false);
        }, 900);
      });
  };

  return (
    <IconTooltip
      icon="fa-cog"
      placement="right"
      className="clickable"
      onClick={copy}
      note={copying ? "Copied!" : note}
    />
  );
}

NetWeightAndDimsPopUp.propTypes = {
  part: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/NetWeightAndDimsPopUp.jsx